import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3eb46b9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-checkbox-container" }
const _hoisted_2 = ["checked", "disabled"]
const _hoisted_3 = {
  key: 0,
  for: "base-checkbox",
  class: "base-checkbox-label"
}

interface Props {
  checked: boolean;
  disabled: boolean;
  type: 'base' | 'close';
  label: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseCheckbox',
  props: {
    checked: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    type: { default: 'base' },
    label: { default: '' }
  },
  emits: ['update:checked'],
  setup(__props: any, { emit }) {

const props = __props;





const update = (event: Event) => {
  emit('update:checked', (event.target as HTMLInputElement).checked);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      id: "base-checkbox",
      type: "checkbox",
      checked: props.checked,
      disabled: props.disabled,
      class: "base-checkbox",
      onChange: update
    }, null, 40, _hoisted_2),
    (props.label)
      ? (_openBlock(), _createElementBlock("label", _hoisted_3, _toDisplayString(props.label), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})